import { render, staticRenderFns } from "./CbsUserMenu.vue?vue&type=template&id=d3064d7c&scoped=true"
import script from "./CbsUserMenu.vue?vue&type=script&lang=js"
export * from "./CbsUserMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3064d7c",
  null
  
)

export default component.exports